/**
 * Provides constant values for camera lens projection options use the the <code>coordinateSystem</code> property
 *
 * @see away.projections.PerspectiveLens#coordinateSystem
 */
export var CoordinateSystem;
(function (CoordinateSystem) {
    /**
     * Default option, projects to a left-handed coordinate system
     */
    CoordinateSystem[CoordinateSystem["LEFT_HANDED"] = 0] = "LEFT_HANDED";
    /**
     * Projects to a right-handed coordinate system
     */
    CoordinateSystem[CoordinateSystem["RIGHT_HANDED"] = 1] = "RIGHT_HANDED";
})(CoordinateSystem || (CoordinateSystem = {}));
